import styled from "styled-components";

export const Wrapper = styled.div`
.bdr{border:1px solid red !important;}


`;
